const DAYS_MAPPER = {
  0: 'dní',
  1: 'den',
  2: 'dny',
  3: 'dny',
  4: 'dny',
  5: 'dnů',
}

export const daysAgo = (date) => {
  const now = new Date()
  const past = new Date(date)
  const diffTime = Math.abs(now - past)
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60))

  if (diffHours < 24) {
    return diffHours === 0 ? 'méně než hodinu' : `${diffHours} ${diffHours === 1 ? 'hodina' : diffHours < 5 ? 'hodiny' : 'hodin'}`
  }

  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  return `${diffDays} ${diffDays === 1 ? 'den' : diffDays < 5 ? 'dny' : 'dní'}`
}

export const timeToSell = (created, lastUpdated, inactive) => {
  if (!inactive) return null

  if (!created || !lastUpdated) return null

  const createdDate = new Date(created)
  const lastUpdatedDate = new Date(lastUpdated)
  const diffTime = Math.abs(lastUpdatedDate - createdDate)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (diffDays <= 0) return null

  const days = diffDays === 1 ? 'den' : diffDays < 5 ? 'dny' : 'dní'
  return `${diffDays} ${days}`
}
